<div *ngIf="cellIsUserInfo(cell)" class="user-info">
  <p>{{ cell.fullName }}</p>
  not implemented
</div>

<div *ngIf="cellIsGeneralInfo(cell)" class="general">
  <div class="avatar-cell-text">
    <div class="main-text">
      {{ cell.mainText }}
      <span *ngIf="cell.tooltip" class="moecs-checkmark" [title]="cell.tooltip">✓</span>
    </div>
    <div class="sub-text">
      <p>{{ cell.subText }}</p>
    </div>
  </div>
</div>

<div *ngIf="cellIsStatusInfo(cell)" [ngClass]="['status', cell.statusType, cell.statusKid]">
  <p>
    {{
    cell.forceUppercase
    ? cell.statusDisplay.toLocaleUpperCase()
    : cell.statusDisplay
    }}
  </p>
</div>

<div *ngIf="cellIsRole(cell)" [ngClass]="['role', cell.statusType, cell.roleKid]" class="role-cell">
  <mat-icon *ngIf="cell.roleKid !== 'DEFAULT_USER' && cell.roleKid !== 'DISTRICT_PRIMARY'">lock</mat-icon>
  <mat-icon *ngIf="cell.roleKid === 'DISTRICT_PRIMARY'">star</mat-icon>
  <p>
    {{
    cell.roleKid === 'DISTRICT_PRIMARY'
    ? 'Account Holder'
    : (cell.forceUppercase
    ? cell.roleDisplay.toLocaleUpperCase()
    : cell.roleDisplay)
    }}
  </p>
</div>

<div *ngIf="cellIsSpecialInfo(cell)" class="special">
  <p>
    {{ cell.specialType }}
  </p>
  not implemented
</div>

<div *ngIf="cellIsHyperlink(cell)" class="hyperlink">
  <span>{{ cell.url }}</span>
</div>

<div *ngIf="cellIsIcon(cell)" class="unknown">
  <mat-icon *ngIf="cell.display" [ngStyle]="{ color: cell.color }" aria-label="icon" [title]="cell.helperText || ''">{{
    cell.icon }}</mat-icon>
</div>

<ng-template #unknown>Unknown data type</ng-template>

<ng-container *ngIf="isAvatarCell(cell)">
  <div class="avatar-cell">
    <app-avatar size="md" [size]="cell.size || 'md'" [firstName]="cell.firstName" [lastName]="cell.lastName">
    </app-avatar>

    <div class="avatar-cell-text">
      <div class="full-name">{{ cell.firstName }} {{ cell.lastName }}</div>
      <div class="email">{{ cell.email }}</div>
    </div>
  </div>
</ng-container>